module.exports = __webpack_public_path__ + "img/Gradient_rainbow.2c917fb0.png";